import Vue from 'vue';
import {
  GETTER_MEDICINE_ORDERS,
  GETTER_ONGOING_MEDICINE_ORDERS,
  GETTER_PAST_MEDICINE_ORDERS,
  GETTER_MEDICINE_ORDERS_LOADING,
  GETTER_MEDICINE_PARTNERS,
  GETTER_MEDICINE_PARTNER,
  GETTER_NEED_ORDER_RELOAD,
  ACTION_CLEAR_MEDICINE_MODULE,
  ACTION_SET_MEDICINE_STATE,
  ACTION_SET_ORDER_LAST_MESSAGE,
  MUTATE_MEDICINE_STATE,
  MUTATE_ORDER_LAST_MESSAGE,
  MUTATE_CLEAR_MEDICINE_MODULE,
} from './types';
import {
  updateStateProps,
  mutateStateProps,
} from './common-functions';
import {
  MEDICINE_ONGOING_STATUS_CODES,
  PHARMACY_OPERATIONAL_HOURS_LABEL_ID,
  GET_PHARMACY_SAME_DAY_DELIVERY_CUTOFF_LABEL_ID,
  PARTNER_TYPES,
} from '@/reference/medicine';
import {formatAddressObjtoString} from '@/utils';

const defaultState = () => ({
  orders: null,
  partners: [],
  loading: false,
  /**
   * if this is true, when user visits ongoing or past orders, refetch the orders list just to update the list
   */
  needToReload: false,
});

const state = defaultState();

const getters = {
  [GETTER_MEDICINE_ORDERS]: (state) => {
    if (!state.orders || !Array.isArray(state.orders)) return state.orders;

    return state.orders
      // hide home service labs temporarily (bring it back if home service labs details is supported)
      .filter(({ordertype}) => ordertype !== PARTNER_TYPES.homeservicelabs)
      .map((order) => {
        return {
          ...order,
          addressString: formatAddressObjtoString(order.address),
        };
      });
  },
  [GETTER_MEDICINE_ORDERS_LOADING]: ({loading}) => loading,
  [GETTER_ONGOING_MEDICINE_ORDERS]: (state, getters) => {
    if (!getters[GETTER_MEDICINE_ORDERS]) return [];

    return getters[GETTER_MEDICINE_ORDERS]
      .filter(({status}) => MEDICINE_ONGOING_STATUS_CODES.includes(status));
  },
  [GETTER_PAST_MEDICINE_ORDERS]: (state, getters) => {
    if (!getters[GETTER_MEDICINE_ORDERS]) return [];

    return getters[GETTER_MEDICINE_ORDERS]
      .filter(({status}) => !MEDICINE_ONGOING_STATUS_CODES.includes(status))
  },
  [GETTER_MEDICINE_PARTNERS]: ({partners}) => partners,
  [GETTER_MEDICINE_PARTNER]: (state, getters) => (partnercode) => {
    const partner = getters[GETTER_MEDICINE_PARTNERS].find((partner) => partner.partnercode === partnercode);

    if (partner) {
      partner.operationHoursLabelId = PHARMACY_OPERATIONAL_HOURS_LABEL_ID[partner.partnercode];
      partner.sameDayDeliveryCutOffLabelId = GET_PHARMACY_SAME_DAY_DELIVERY_CUTOFF_LABEL_ID(partner.partnercode);
    }

    return partner;
  },
  [GETTER_NEED_ORDER_RELOAD]: ({needToReload}) => needToReload,
};

const actions = {
  [ACTION_SET_MEDICINE_STATE]: updateStateProps(MUTATE_MEDICINE_STATE),
  [ACTION_SET_ORDER_LAST_MESSAGE]: ({commit}, message) => {
    commit(MUTATE_ORDER_LAST_MESSAGE, message);
  },
  [ACTION_CLEAR_MEDICINE_MODULE]: ({commit}) => {
    commit(MUTATE_CLEAR_MEDICINE_MODULE);
  },
};

const mutations = {
  [MUTATE_MEDICINE_STATE]: mutateStateProps,
  [MUTATE_ORDER_LAST_MESSAGE]: (state, message) => {
    const orderIndex = state.orders.findIndex(({orderid}) => orderid === message.orderid);
    const order = state.orders[orderIndex];

    Vue.set(
      state.orders,
      orderIndex,
      {
        ...order,
        lastMessageDate: message.date,
        lastOrderMessage: message,
      },
    );
  },
  [MUTATE_CLEAR_MEDICINE_MODULE]: (state) => {
    Object.assign(state, defaultState());
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
